// pages/AdminRegister.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from "@mui/material";
import userService from "../../services/userService";

export default function Register() {
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone:"",
    userType:"admin",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    try {
        const data = await userService.newAdmin(form);
        setSuccess("Admin created successfully. Redirecting to login...");
        setTimeout(() => navigate("/admin/login"), 2000);
    } catch (err) {
        setError(err.message);
    }
    
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 6 }}>
      <Typography variant="h4" gutterBottom>
        Register New Admin
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

      <Box display="flex" flexDirection="column" gap={2}>
        <TextField
          label="First Name"
          name="firstname"
          value={form.firstname}
          onChange={handleChange}
          required
        />
        <TextField
          label="Last Name"
          name="lastname"
          value={form.lastname}
          onChange={handleChange}
          required
        />
        <TextField
          label="Email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <TextField
          label="Password"
          name="password"
          type="password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <Button variant="contained" onClick={handleSubmit}>
          Register Admin
        </Button>
      </Box>
    </Container>
  );
}